import { render, staticRenderFns } from "./TabFood.vue?vue&type=template&id=4e6f8547"
import script from "./TabFood.vue?vue&type=script&lang=js"
export * from "./TabFood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports